import { render } from "./renderless-entrepreneur-assessment.vue?vue&type=template&id=bdbd2ef8&ts=true"
import script from "./renderless-entrepreneur-assessment.vue?vue&type=script&lang=ts"
export * from "./renderless-entrepreneur-assessment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__